import script from "./ExternalNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalNavBar.vue?vue&type=script&setup=true&lang=js"

import "./ExternalNavBar.vue?vue&type=style&index=0&id=05accb39&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05accb39"]])

export default __exports__